import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { ColumnOrderDialogComponent } from "../grid-column-preferences/column-order-dialog/column-order-dialog.component";
import { GridColumn } from "../../../modules/preferences/models/preferences.model";

@Component({
  selector: "app-grid-column-preferences",
  templateUrl: "./grid-column-preferences.component.html",
  styleUrls: ["./grid-column-preferences.component.scss"],
})
export class GridColumnPreferencesComponent implements OnChanges {
  constructor(private dialog: MatDialog) {}

  @Input()
  columns: GridColumn[] = [];

  @Output()
  columnsChanged = new EventEmitter<GridColumn[]>();

  /**
   * Selected GridIds for mat-select
   */
  selectedColumns: number[] = [];

  /**
   * Whenever parent updates the columns,
   * refresh the selected values.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.columns && this.columns) {
      this.selectedColumns = this.columns
        .filter((x) => x.IsSelected)
        .map((x) => x.GridId);
    }
  }

  /**
   * Show / Hide changed
   */
  selectionChanged(): void {
    this.columns.forEach((column) => {
      column.IsSelected = this.selectedColumns.includes(column.GridId);
    });

    this.emitColumns();
  }

  /**
   * Open Column Order Dialog
   */
  openColumnOrder(): void {
    const dialogRef = this.dialog.open(ColumnOrderDialogComponent, {
      disableClose: true,
      width: "600px",
      data: {
        columns: JSON.parse(
          JSON.stringify(
            this.columns.filter((x) => x.IsSelected).sort((a, b) => a.DisplayOrder - b.DisplayOrder),
          ),
        ),
      },
    });

    dialogRef.componentInstance.orderChanged.subscribe(
      (orderedColumns: GridColumn[]) => {
        orderedColumns.forEach((updated) => {
          const original = this.columns.find(
            (x) => x.GridId === updated.GridId,
          );
          if (original) {
            original.DisplayOrder = updated.DisplayOrder;
          }
        });
        this.emitColumns();
      },
    );

    dialogRef.afterClosed().subscribe((orderedColumns: GridColumn[]) => {
      if (!orderedColumns) {
        return;
      }

      orderedColumns.forEach((updated) => {
        const original = this.columns.find((x) => x.GridId === updated.GridId);

        if (original) {
          original.DisplayOrder = updated.DisplayOrder;
        }
      });

      this.emitColumns();
    });
  }

  /**
   * Emit updated columns to parent
   */
  private emitColumns(): void {
    this.columnsChanged.emit([...this.columns]);
  }
}
